import React, { useContext } from 'react';

import { Button, Spinner } from 'reactstrap';
import { IRootState } from 'app/shared/reducers';
import { useDispatch, useSelector } from 'react-redux';
import { IsMobile } from 'app/app'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { goNextStep, goPreviousStep } from 'app/modules/journey/service/step.service';
import './step-actions.scss';
import { getCurrentJourneyStep } from 'app/modules/journey/service/store/step.selector';

const StepActions = () => {

  const isMobile = useContext(IsMobile);

  const dispatch = useDispatch();

  const showPreviousButton = useSelector((state: IRootState) => state.step.showPreviousButton)
  const previousButtonLabel = useSelector((state: IRootState) => state.step.previousButtonLabel)
  const disableButtons = useSelector((state: IRootState) => state.step.disableButtons)
  const disableNextButton = useSelector((state: IRootState) => state.step.disableNextButton)
  const disablePreviousButton = useSelector((state: IRootState) => state.step.disablePreviousButton)
  const showNextButton = useSelector((state: IRootState) => state.step.showNextButton)
  const nextButtonLabel = useSelector((state: IRootState) => state.step.nextButtonLabel)
  const createInProgress = useSelector((state: IRootState) => state.subscription.createInProgress)
  const fullSize = useSelector((state: IRootState) => state.step.fullSize)
  const currentStep = useSelector(getCurrentJourneyStep);

  const productCode = useSelector((state: IRootState) => state.config.productCode);

  const handleGoToNexStepEvent = (): void => {
    dispatch(goNextStep());
  }

  const handleGoToPreviousStepEvent = (): void => {
    dispatch(goPreviousStep());
  }

  if (productCode !== 850) {
    if (isMobile && productCode !== 850) {
      return (
        <>
          <div className="navigationMobileBtnFlexBox">
            {showPreviousButton ?
              <Button onClick={handleGoToPreviousStepEvent} className="button previousButton" disabled={disableButtons || disablePreviousButton} >
                <span id="previousStepButton">
                  {/* <FontAwesomeIcon icon="arrow-left" /> */}
                  <FontAwesomeIcon icon="chevron-left" />
                  {previousButtonLabel}
                </span>
              </Button>
              : <div></div>
            }
            {showNextButton &&
              <Button type="submit" onClick={handleGoToNexStepEvent} className="button nextButton" disabled={disableButtons || disableNextButton} style={{ width: fullSize && '100%' }}>
                {createInProgress === true && <Spinner size="sm" color="primary" style={{ marginRight: 8 }} />}
                <span id="previousStepButton">
                  {/* {currentStep === 'confirmOfferStep' ? nextButtonLabel : ''} */}
                  {nextButtonLabel}
                  {/* <FontAwesomeIcon icon="arrow-right" /> */}
                </span>
              </Button>
            }
          </div>
        </>
      );

    } else {

      return (
        <div className="row buttonRow">
          {showPreviousButton ?
            <div className="float-left" onClick={handleGoToPreviousStepEvent}>
              <Button tabIndex={1} className="button previousButton" disabled={disableButtons || disablePreviousButton}>
                {/* <i className="zmdi zmdi-arrow-left" /> */}
                <FontAwesomeIcon icon="chevron-left" />
                <span>{previousButtonLabel}</span>
              </Button>
            </div>
            : <div></div>
          }
          {showNextButton &&
            <div className={showPreviousButton && "float-right"} onClick={handleGoToNexStepEvent}>
              <Button tabIndex={0} className={"button nextButton"} disabled={disableButtons || disableNextButton}>
                {createInProgress === true && <Spinner size="sm" color="primary" style={{ marginRight: 8 }} />}
                <span>
                  {nextButtonLabel}
                  {/* <FontAwesomeIcon icon="arrow-right" /> */}
                </span>
              </Button>
            </div>}
        </div>
      );
    }
  } else {
    return <></>
  }
};

export default StepActions;
